import { CheckboxInput } from '@/shared/ui';
import {
  STATUS_CHECKBOX,
  numberWithCommas,
} from '@/widgets/beats/ui/rrInterval/heatMapChart/handler';
import useHeaderChart from './useHeaderChart';
import './styles.scss';

export type HeaderChartProps = {
  activeButton: string;
};

/**
 * Renders the R-R heatmap header showing how many cells are selected, how many beats they hold and a reviewed checkbox. Hides the counters entirely while nothing is selected, and drives the checkbox from typeCheckbox so it reads indeterminate when only part of the selection is reviewed.
 *
 * @param props - Header inputs including the active beat type, forwarded to useHeaderChart for the selection totals.
 * @returns The heatmap header with its selection counters and reviewed checkbox.
 */
const HeaderChart = ({ activeButton }: HeaderChartProps) => {
  const { listSelectedCells, totalSelectedBeats, totalBeats, typeCheckbox, onClickCheckbox } =
    useHeaderChart({ activeButton });

  return (
    <div className="header-chart">
      <h4 className="title">R-R heatmap:</h4>
      {listSelectedCells.length !== 0 && (
        <>
          <div className="selected">
            {totalSelectedBeats > 1 ? `${totalSelectedBeats} cells` : `${totalSelectedBeats} cell`}{' '}
            selected{' '}
          </div>
          <div className="gap" />
          <div className="beats">{`${numberWithCommas(totalBeats)} ${totalBeats > 1 ? 'beats' : 'beat'}`}</div>
          <div className="gap" />
          <div className="reviewed">
            <CheckboxInput
              id="reviewedColumn"
              name="reviewedColumn"
              isIndeterminate={typeCheckbox === STATUS_CHECKBOX.INDETERMINATE}
              isSpecial
              data={{
                label: 'Reviewed',
              }}
              checked={typeCheckbox === STATUS_CHECKBOX.CHECK}
              onClick={onClickCheckbox}
              disabled={listSelectedCells.length === 0}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default HeaderChart;
